import React, { Component } from "react";
import heroHeader from "../assets/img/hero-header.png";

import Feature from "../components/Feature";
import AboutUs from "../components/AboutUs";
import Services from "../components/Service";
import Newsletter from "../components/Newsletter";
import ContactUs from "../components/ContactUs";

import SEO from "../components/SEO";

import { getSEO } from "../services/seoService";
import { getCMS } from "../services/cmsService";

export class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      seo: null,
      cms: [],
    };
  }

  async componentDidMount() {
    try {
      const seoData = await getSEO("home");
      const cmsData = await getCMS("home");

      this.setState({
        seo: seoData,
        cms: cmsData,
      });

      console.log("SEO DATA:", seoData);
      console.log("CMS DATA:", cmsData);
    } catch (error) {
      console.log("ERROR:", error);
    }
  }

  render() {
    const { cms, seo } = this.state;

    const firstTitle = cms.find(
      (item) => item.content_type === "1"
    );

    const highlightTitle = cms.find(
      (item) => item.content_type === "9"
    );

    const secondTitle = cms.find(
      (item) => item.content_type === "2"
    );

    const buttonText = cms.find(
      (item) => item.content_type === "10"
    );
    const heroImage = cms.find(
      (item) => item.content_type === "1"
    );

    return (
      <>
        <SEO seo={seo} />

        <div>
          {/* Hero Start */}
          <div className="container-fluid pb-5 hero-header mb-5">
            <div className="container py-5">
              <div className="row g-5 align-items-center">
                <div className="col-lg-6">

                  <h1 className="display-3 mb-4 animated slideInRight">
                    {firstTitle?.content_title || "We Create"}{" "}

                    <span style={{ color: "#b68527" }}>
                      {highlightTitle?.content_title || "Digital"}
                    </span>{" "}

                    {secondTitle?.content_title ||
                      "Experiences That Drive Results"}
                  </h1>

                  <p className="fs-5 d-inline-block rounded bg-primary text-white py-3 px-4 mb-0 animated slideInRight">
                    {buttonText?.content_title || "View Our Work"}
                  </p>

                </div>

                <div className="col-lg-6">
                  <img
                    className="img-fluid animated slideInRight"
                    src={
                      heroImage?.content_image
                        ? heroImage.content_image
                        : heroHeader
                    }
                    alt="Ideal Technoride"
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Hero End */}

          <AboutUs />
          <Feature />
          <Services />
          <Newsletter />
          <ContactUs />
        </div>
      </>
    );
  }
}

export default Home;